import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCalculatedFarmFootprintByYear } from "services";

import { getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedFarmFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_FARM_CALCULATED_FOOTPRINT, farmId, year],
      queryFn: () => getCalculatedFarmFootprintByYear(year),
      enabled: enabled && !!farmId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      queryClient,
      gcTime: 60000,
    })),
  });
};
